import React from "react";
import { ElementFactory, Question, Serializer, settings } from "survey-core";
import { type SurveyCreatorModel } from "survey-creator-core";
import { ReactQuestionFactory } from "survey-react-ui";
import LoginDetailsQuestionComponent, {
  custom_question_login_details,
} from "shared/components/survey-js-form/questions/login-details/LoginDetailsQuestionComponent";
import { type SessionView } from "shared/mappers/database/session/session";

export type LoginDetailsFormValues = {
  user_name: string;
  password?: string;
  password_confirm?: string;
  old_password?: string;
};

export type LoginDetailsQuestionRendererInputProps = {
  question: Question;
  session: SessionView;
};

export class LoginDetailsQuestionModel extends Question {
  getType() {
    return custom_question_login_details;
  }
}

(settings as { customIcons: { [index: string]: string } }).customIcons[
  `icon-${custom_question_login_details}`
] = "icon-search";

export const LoginDetailsQuestionRenderer = ({
  question,
}: LoginDetailsQuestionRendererInputProps) => {
  return LoginDetailsQuestionComponent(question);
};

export const RegisterLoginDetailsQuestionType = (
  creator?: SurveyCreatorModel,
) => {
  registerProperties();

  creator?.onQuestionAdded.add((sender: SurveyCreatorModel, options) => {
    if (options.question?.getType() === custom_question_login_details) {
      options.question.name = custom_question_login_details;
      options.question.title = custom_question_login_details;
    }
  });

  ElementFactory.Instance.registerElement(
    custom_question_login_details,
    (name) => new LoginDetailsQuestionModel(name),
  );

  ReactQuestionFactory.Instance.registerQuestion(
    custom_question_login_details,
    (props: any) => {
      return React.createElement(LoginDetailsQuestionRenderer, {
        ...props,
      });
    },
  );
};

const registerProperties = () => {
  Serializer.addClass(
    custom_question_login_details,
    [],
    () => new LoginDetailsQuestionModel(""),
    "question",
  );

  Serializer.addProperty(custom_question_login_details, {
    name: "changePasswordTitle",
    type: "text",
    category: "general",
  });

  Serializer.addProperty(custom_question_login_details, {
    name: "customConflictErrorMessage",
    type: "text",
    category: "general",
    displayName: "Custom Username Conflict Error",
  });

  Serializer.getProperty(custom_question_login_details, "name").readOnly = true;

  [
    "visible",
    "isRequired",
    "readOnly",
    "visibleIf",
    "enableIf",
    "requiredIf",
    "clearIfInvisible",
    "defaultValueExpression",
    "defaultValue",
    "startWithNewLine",
    "valueName",
    "useDisplayValuesInTitle",
    "correctAnswer",
    "requiredErrorText",
    "validators",
  ].forEach((propertyName) => {
    Serializer.getProperty(
      custom_question_login_details,
      propertyName,
    ).visible = false;
  });
};
